import Text from "hardcover-ui/components/Text";
import { TagSerializersTaggingToBasicTag } from "types/serializers";

export default function JournalTags({ tags }: { tags: TagSerializersTaggingToBasicTag[] }) {
  if (tags.length === 0) {
    return false;
  }

  return (
    <div className="flex flex-row space-x-2">
      {tags.map((tag) => (
        <Text key={tag.tag} variant="secondary" size="sm">
          #{tag.tag}
        </Text>
      ))}
    </div>
  );
}
